module.exports = __webpack_public_path__ + "_assets/img/favicon.d112e6d6.svg";